import type { Authority } from 'Services/common/Features/Authority/types'
import { useEffect } from 'react'

export function useAutoSelectAuthority<T extends { authority_code: string | null }>(
  isNewInstance: boolean,
  authorities: Authority[],
  setDetails: React.Dispatch<React.SetStateAction<T>>
) {
  useEffect(() => {
    // Set the authority code to the only available authority if there's only one available
    if (isNewInstance && authorities?.length === 1) {
      setDetails(prevState => ({
        ...prevState,
        authority_code: authorities?.at(0)?.code ?? ''
      }))
    }
  }, [isNewInstance, authorities, setDetails])
}
